import { render, staticRenderFns } from "./LoanDetailsPopover.vue?vue&type=template&id=ad15492a"
import script from "./LoanDetailsPopover.vue?vue&type=script&lang=js"
export * from "./LoanDetailsPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports